export default __webpack_public_path__ + "9fb8e6c2c71b4d27cc493c32e7ef372b.png";